import axiosClient from "@/shared/lib/axios/axios";
import { ApiResponse } from "@/shared/types/api";
import { API_ROUTES } from "../config";
import {
  ClassificationTaxonomy,
  ObjectPresenceTaxonomy,
} from "../../types/taxonomy";

export const getClassificationTaxonomy = async (): Promise<ClassificationTaxonomy | null> => {
  const res = await axiosClient.get<ApiResponse<ClassificationTaxonomy>>(
    API_ROUTES.CLASSIFICATION_TAXONOMY,
    { params: { schema: "v2" } }
  );
  return res?.data?.data ?? null;
};

export const getObjectPresenceTaxonomy = async (): Promise<ObjectPresenceTaxonomy | null> => {
  const res = await axiosClient.get<ApiResponse<ObjectPresenceTaxonomy>>(
    API_ROUTES.OBJECT_PRESENCE_TAXONOMY
  );
  return res?.data?.data ?? null;
};
